import type { CharacterProgression } from "@/game/model/character-progression";
import {
  ratingsFromAllocation,
  type CombatRatings,
  type StatAllocation,
} from "@/game/model/character-stats";

/** Pet uses owner level; only pet stat allocation affects ratings. */
export function petCombatRatings(
  progression: CharacterProgression,
  allocation: StatAllocation,
  buffBonus?: Partial<StatAllocation>,
): CombatRatings {
  const merged: StatAllocation = { ...allocation };
  if (buffBonus) {
    for (const key of Object.keys(buffBonus) as (keyof StatAllocation)[]) {
      const n = buffBonus[key];
      if (typeof n === "number" && n > 0) merged[key] = (merged[key] ?? 0) + n;
    }
  }
  return ratingsFromAllocation(progression.level, merged);
}
